module.exports = __webpack_public_path__ + "img/header_2.0858c5c5.png";